import {useEffect, useState} from 'react';
import {previewCookieName} from './const';
import filterDataToSingleItem, {
  getCookie,
  useSanityPreviewClient,
} from './utils';

export default function useSanityData(
  serverData: any,
  sanityQuery: string,
  sanityParams: {slug: string},
) {
  const [sanityData, setSanityData] = useState(serverData);
  let timeToFetchAfterMutation: any;

  // useEffect only runs on client
  useEffect(() => {
    if (!!getCookie(previewCookieName)) {
      // We are in preview mode, get preview data from Sanity
      const client = useSanityPreviewClient;

      // Initial update to show preview data
      client.fetch(sanityQuery, sanityParams).then(
        (result) => {
          const initialData = filterDataToSingleItem(result, true);
          setSanityData(initialData);
        },
        (reason) => {
          console.log('Error fetching initial Sanity data:', reason);
        },
      );

      // Subscribe to updates from Sanity
      client
        .listen(sanityQuery, sanityParams, {includeResult: false})
        .subscribe(() => {
          // Fetch data again as update happened
          clearTimeout(timeToFetchAfterMutation);
          timeToFetchAfterMutation = setTimeout(() => {
            client.fetch(sanityQuery, sanityParams).then(
              (result) => {
                const updatedData = filterDataToSingleItem(result, true);
                console.log('Sanity data update');
                setSanityData(updatedData);
              },
              (reason) => {
                console.log('Error fetching updated Sanity data:', reason);
              },
            );
          }, 1000);
        });
    }
  }, []);

  return sanityData;
}
